import { useSnackbar } from 'notistack';
import { Dispatch, useEffect, useState } from 'react';
import { checkResData } from '../../../../utils/common';
import { createCalendarUrl } from '../../../../apicalls/calender';

export type Props = {
  setIsOpen: Dispatch<boolean>;
  isOpen: boolean;
  userId: number;
};

export const useHooks = (props: Props) => {
  const { setIsOpen, isOpen, userId } = props;

  // ローディング用
  const [isLoading, setIsLoading] = useState(true);
  // 発行されたURL
  const [publishedUrl, setPublishedUrl] = useState('');

  // リンクをコピーボタン押下時のハンドラ
  const handleOnClickCopyLink = () => {
    global.navigator.clipboard.writeText(publishedUrl);
  };

  // キャンセル時の処理
  const closeModal = () => {
    setIsOpen(false);
  };

  // snackbar
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    if (isOpen) {
      setIsLoading(true);

      createCalendarUrl(userId).then((resData: any) => {
        checkResData(resData, enqueueSnackbar).then((data: any) => {
          if (data && data.data && data.data.url) {
            setPublishedUrl(data.data.url);
          }
          setIsLoading(false);
        });
      });
    }
  }, [isOpen]);

  return {
    closeModal,
    publishedUrl,
    handleOnClickCopyLink,
    isLoading
  };
};
